
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'DealStatisticsCard'
})
class DealStatisticsCard extends Vue {
  @Prop() readonly statistic!: any
}

export default DealStatisticsCard
